import { render, staticRenderFns } from "./PDFEdit.vue?vue&type=template&id=26fab2dc&"
import script from "./PDFEdit.vue?vue&type=script&lang=js&"
export * from "./PDFEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports